export default __webpack_public_path__ + "static/media/three-star.9c0ceb08.svg";